import React, { Component } from 'react';
import { Link, Route } from 'react-router-dom';
import { API_HOST } from '../../constants/server.constant';
import ResourceService from '../../services/resource.service';
import CommonMessage from '../common/commonMessage';
import $ from 'jquery';
import Validate from './../common/validate';
import Axios from 'axios';
import { axiosRequestWithAuth, axiosInstance } from './../../constants/server.constant';
import QRCode from "qrcode.react";
import { SessionService } from './../../services/session.service';
import ReCAPTCHA from "react-google-recaptcha";
import { userService } from "./../../services/user.service";
import { loginService } from '../../services/login.service';

export class Security extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isContinue: true,
            isAction: false,
            twofaBlock: false,
            currentRadioButton: "twofaEmail",
            isCodeVerication: false,
            isTwoFAEmail: false,
            isTwoFAPhone: false,
            isTwoFAPhoneVer1: false,
            isTwoFAPhoneVer2: false,
            isTwoFATotp: false,
            isTwoFATotpstp1: false,
            isTwoFATotpstp2: false,
            isTwoFATotpstp3: false,
            emailOtp: "",
            phoneOtp: "",
            tOtp: "",
            showTimer: false,
            userId: localStorage.getItem("userId"),
            userEmail: localStorage.getItem("email"),
            roleId: localStorage.getItem("roleId"),
            userPhone: "",
            countryCode: "USA +1",
            otpempty: false,
            otpErr: false,
            phoneEmpty: false,
            phoneError: false,
            phoneOtpEmpty: false,
            phoneOtpError: false,
            clickFromEmail: false,
            qrValue: "",
            isQrShown: true,
            secretKey: "",
            recoveryCode: "",
            totpCode: "",
            totpEmpty: false,
            totpError: false,
            isCodeStp2: false,
            isCodePopup: false,
            isCodeStp1: false,
            isTotpMsg: false,
            isViewMsg: false,
            viewTotpMessage: "",
            viewCodeMessage: "",
            switchTwoFAPop: false,
            clickedItem: "",
            clickedLink: "",
            alreadySelectItem: "",
            isResend: false,
            disableResendEmail: false,
            disableResendPhone: false,
            isthirdpartylogin: false,
            thirdPartyName: 'Google'
        };
        this.emailOtpInput = React.createRef();
        this.phoneInputFocus = React.createRef();
        this.phoneOtpFocus = React.createRef();
        this.viewCodeInput = React.createRef();
        this.totpCodeInput = React.createRef();
        this.getUserInfo = this.getUserInfo.bind(this);
        this.handleRadioButtons = this.handleRadioButtons.bind(this);
        this.submitRadioSelection = this.submitRadioSelection.bind(this);
        this.closeEmailBox = this.closeEmailBox.bind(this);
        this.handleInputs = this.handleInputs.bind(this);
        this.startTimer = this.startTimer.bind(this);
        this.sendEmailOtp = this.sendEmailOtp.bind(this);
        this.resendEmailOtp = this.resendEmailOtp.bind(this);
        this.verifyEmailOtp = this.verifyEmailOtp.bind(this);
        this.phoneBackButton = this.phoneBackButton.bind(this);
        this.sendPhoneOtp = this.sendPhoneOtp.bind(this);
        this.resendPhoneOtp = this.resendPhoneOtp.bind(this);
        this.verifyPhoneOtp = this.verifyPhoneOtp.bind(this);
        this.fromEmailLink = this.fromEmailLink.bind(this);
        this.gotoTotpStp2 = this.gotoTotpStp2.bind(this);
        this.gotoTotpStp3 = this.gotoTotpStp3.bind(this);
        this.copyRecoveryCode = this.copyRecoveryCode.bind(this);
        this.downloadRecoveryCode = this.downloadRecoveryCode.bind(this);
        this.printRecoveryCode = this.printRecoveryCode.bind(this);
        this.escfunction = this.escfunction.bind(this);
        this.enableSwitchPop = this.enableSwitchPop.bind(this);
        this.recaptchaRef = React.createRef();
    }

    componentDidMount() {
        this.checkTwoFAStatus();
        document.addEventListener("keyup", this.escfunction, false);
        this.setState({
            isAction: true
        });
        userService.getUserDetails().then(res => {
            if(res === false) {
                this.setState({
                    message: "Error while fetching user details",
                    msgType: "error",
                    isAction: false
                });
                return;
            }
            if(res.data.hasOwnProperty("body")) {
                let body = res.data.body;
                if(body.thirdPartyUser && body.thirdPartyUser.psswdStatus.toString() === 'N') {
                    let thirdPartyName = 'Google';
                    if(body.thirdPartyUser.source === 'GitHub') {
                        thirdPartyName = 'GitHub';
                    }
                    this.setState({
                        isthirdpartylogin: true,
                        isAction: false,
                        thirdPartyName: thirdPartyName
                    });
                }
            }
        });
    }
    componentWillUnmount() {
        clearInterval(this.timerId);
        document.removeEventListener("keyup", this.escfunction, false);
    }
    escfunction(event) {
        if(event.keyCode === 27) {
            this.setState({
                isTotpApps: false,
                isTwoFATotp: false,
                isTwoFATotpstp1: false,
                isTwoFATotpstp2: false,
                isTwoFATotpstp3: false,
                switchTwoFAPop: false,
                isCodePopup: false,
                isCodeStp1: false,
                isCodeStp2: false
            });

        }
    }
    checkTwoFAStatus = () => {
        this.setState({
            isAction: true
        });
        axiosInstance.get(API_HOST + "/user/getuserinfo/" + this.state.userId, axiosRequestWithAuth).then(resp => {
            this.setState({
                isAction: false
            });
            let info = resp.data.body;
            if(info && info.hasOwnProperty("parent_user_id")) {

                if(info.is_2fa_enabled == 1) {
                    this.getUserInfo();
                    this.getUserData();
                }
                else {
                    loginService.redirectToLogin();
                }
            }
            else {
                this.getUserInfo();
                this.getUserData();
            }
            // console.log(info)
            // if(info.hasOwnProperty("user")){
            //     if(info.user.thirdPartyUser && info.user.thirdPartyUser.psswdStatus.toString() === 'N'){
            //         this.setState({
            //             isthirdpartylogin : true
            //         })
            //     }
            // }

        }).catch(err => {
            this.setState({
                isAction: false
            });
        });
    };

    getUserData = () => {
        axiosInstance.get(API_HOST + "/user/" + this.state.userId, axiosRequestWithAuth).then(resp => {
            let userd = resp.data.body;
            this.setState({
                isAction: false,
                countryCode: userd.countryCode != "" && userd.countryCode != null ? userd.countryCode : this.state.countryCode,
                userPhone: userd.phone != "" && userd.phone != null ? userd.phone : this.state.phone
            });
        }).catch(err => {
            this.setState({
                isAction: false
            });
        });
    };
    getUserInfo = () => {
        this.setState({
            isAction: true
        });

        axiosInstance.get(API_HOST + "/user/getuserinfo/" + this.state.userId, axiosRequestWithAuth).then(resp => {

            this.setState({
                isAction: false
            });
            let info = resp.data.body;
            if(info === "NOT_FOUND") {
                this.setState({
                    twofaBlock: true,
                    isCodeVerication: true
                });
            }
            else {
                if(info.auth_type === 1) {
                    this.setState({
                        showResult: true,
                        currentRadioButton: "twofaEmail"
                    });
                }
                else if(info.auth_type === 2) {
                    this.setState({
                        showResult: true,
                        currentRadioButton: "twofaPhone"
                    });
                }
                else if(info.auth_type === 3) {
                    this.setState({
                        showResult: true,
                        currentRadioButton: "twofaOtp"
                    });
                }
                else {
                    this.setState({
                        twofaBlock: true,
                        isCodeVerication: true
                    });
                }
            }
        }).catch(error => {
            this.setState({
                isAction: false,
                message: "Error while fetching user details",
                msgType: "error"
            });
        });
    };

    resendEmailOtp = (event) => {
        this.setState({
            isAction: true,
            emailOtp: "",
            message: "",
            msgType: "",
            disableResendEmail: true
        });
        var otpDetails = {
            "email": this.state.userEmail
        };
        setTimeout(() => {
            this.setState({
                disableResendEmail: false
            });
        }, 10000);

        clearInterval(this.timerId);
        ResourceService.sendProfileEmailOtp(otpDetails, event).then(res => {
            if(this.recaptchaRef.current) {
                this.recaptchaRef.current.reset();
            }
            if(res === false) {
                this.setState({
                    isAction: false,
                    message: "Error while sending OTP to email",
                    msgType: 'error'
                });
                return;
            }
            this.setState({
                isAction: false
            });
            if(res === undefined) {
                this.setState({
                    message: "Email not verified",
                    msgType: 'error'
                });
            } else {
                this.setState({
                    isTwoFAEmail: true,
                    isCodeVerication: false,
                    message: "OTP sent to registered email address",
                    showTimer: true
                });
                clearInterval(this.timerId);
                this.startTimer();
            }
        });
    };
    verifyEmailOtp = () => {
        this.setState({
            otpempty: false,
            otpErr: false,
            emailOtp: ""
        });
        if(this.state.emailOtp.trim() == "") {
            this.setState({
                otpempty: true
            });
            this.emailOtpInput.current.focus();
            return;
        }
        else if(!Validate("otp", this.state.emailOtp.trim()) || this.state.emailOtp.trim().length < 6) {
            this.setState({
                otpErr: true
            });
            this.emailOtpInput.current.focus();
            return;
        }
        else {
            this.setState({
                isAction: true
            });
            var otpDetails = {
                "otp": this.state.emailOtp,
                "email": this.state.userEmail
            };
            ResourceService.verifyAccOtp(otpDetails, 1).then(response => {
                if(this.recaptchaRef.current) {
                    this.recaptchaRef.current.reset();
                }
                if(response?.data?.ok) {
                    this.setState({
                        isAction: false,
                        message: "Two-factor authentication is configured",
                        msgType: "",
                        showResult: true,
                        twofaBlock: false,
                        showTimer: false,
                        currentRadioButton: "twofaEmail",
                        isTwoFAEmail: false
                    });
                } else {
                    this.setState({
                        isAction: false,
                        message: "Error while verifying OTP.",
                        msgType: "error"
                    });
                }
            }).catch(error => {
                if(error?.response?.data) {
                    let data = error.response.data;
                    if(data?.error) {
                        switch(data.error) {
                            case "invalid_credentials":
                                this.setState({
                                    isAction: false,
                                    otpErr: true,
                                    message: "Incorrect verification code. Please try again.",
                                    msgType: "error"
                                });
                                return;
                            case "exceeded_retries":
                                this.setState({
                                    isAction: false,
                                    otpErr: true,
                                    message: "Exceeded query limit. Please try after some time.",
                                    msgType: "error"
                                });
                                return;
                            default: break;
                        }
                    }
                }
                this.setState({
                    isAction: false,
                    otpErr: true,
                    message: "Error while verifying OTP",
                    msgType: "error"
                });
                return;
            });
        }

    };
    sendEmailOtp = (event) => {
        this.setState({
            isAction: true,
            disableResendEmail: false,

        });
        var otpDetails = {
            "email": this.state.userEmail,
            "sendEmail": "AFTER_LOGIN"
        };

        clearInterval(this.timerId);
        ResourceService.sendProfileEmailOtp(otpDetails, event).then(res => {
            if(this.recaptchaRef.current) {
                this.recaptchaRef.current.reset();
            }
            if(res === false) {
                this.setState({
                    isAction: false,
                    message: "Error While sending OTP to Email",
                    msgType: 'error'
                });
                return;
            }
            this.setState({
                isAction: false
            });
            if(res === undefined) {
                this.setState({
                    message: "Email not verified",
                    msgType: 'error'
                });
            }
            else if(res === "TOO_MANY_CALLS") {
                this.setState({
                    message: "Too many requests from this IP address. Try again after sometime.",
                    msgType: 'error',
                    twofaBlock: false
                });
            }
            else {
                if(this.state.clickFromEmail) {
                    this.setState({
                        emailOtp: "",
                        showResult: false,
                        isTwoFAEmail: true,
                        showTimer: true,
                        twofaBlock: true,
                        message: "Verification code has been sent",
                        msgType: ""
                    });
                }
                else {
                    this.setState({
                        emailOtp: "",
                        isTwoFAEmail: true,
                        isCodeVerication: false,
                        showTimer: true,
                        message: "Verification code has been sent",
                        msgType: ""
                    });
                }

                this.emailOtpInput.current.focus();
                clearInterval(this.timerId);
                this.startTimer();
            }
        });
    };
    startTimer() {
        //var mindisp = 0;
        //var secdis = 0;
        $("#otp_timer").html("Your verification code will expire in <b> 05:00 </b> Minutes");
        var countdown = 5 * 60 * 1000;
        //var timerId ;
        //clearInterval(timerId);
        this.timerId = setInterval(() => {
            countdown -= 1000;
            var min = Math.floor(countdown / (60 * 1000));
            //var sec = Math.floor(countdown - (min * 60 * 1000));  // wrong
            var sec = Math.floor((countdown - (min * 60 * 1000)) / 1000);
            if(min == 0 && sec == 0) {
                clearInterval(this.timerId);
                if(this.state.isTwoFAEmail) {
                    this.setState({
                        resendOtpTo: "email",
                        isTwoFAEmail: false,
                        isResend: true
                    });
                }
                if(this.state.isTwoFAPhone) {
                    this.setState({
                        resendOtpTo: "phone",
                        isTwoFAPhone: false,
                        isTwoFAPhoneVer1: false,
                        isTwoFAPhoneVer2: false,
                        isResend: true
                    });
                }


            } else {
                this.mindisp = min;
                this.secdis = sec;
                if(min < 10)
                    this.mindisp = "0" + min;
                if(sec < 10)
                    this.secdis = "0" + sec;
                if(min == 0) {
                    $("#otp_timer").html("Your verification code will expire in <b>" + this.mindisp + ":" + this.secdis + "</b> Seconds");
                } else {
                    $("#otp_timer").html("Your verification code will expire in <b>" + this.mindisp + ":" + this.secdis + "</b> Minutes");
                }
            }

        }, 1000);

    }



    handleRadioButtons = (event, param) => {
        let val = event.target.value;
        this.setState({
            currentRadioButton: val
        });
    };
    executeEmailCaptcha() {
        this.setState({ isEmailCaptcha: true }, () => {
            if(this.recaptchaRef.current) {
                this.recaptchaRef.current.execute();
            }
        });
    }
    executeResendEmailCaptcha() {
        this.setState({ isEmailResendCaptcha: true }, () => {
            if(this.recaptchaRef.current) {
                this.recaptchaRef.current.execute();
            }
        });
    }
    submitRadioSelection = (e) => {
        if(this.state.currentRadioButton === "twofaEmail") {
            clearInterval(this.timerId);
            //this.sendEmailOtp()
            this.setState({
                otpempty: false,
                otpErr: false,
            });
            this.executeEmailCaptcha();
        }
        else if(this.state.currentRadioButton === "twofaPhone") {
            clearInterval(this.timerId);
            this.setState({
                isTwoFAPhone: true,
                isTwoFAPhoneVer1: true,
                isCodeVerication: false,
                phoneEmpty: false,
                phoneError: false,
                phoneOtpError: false,
                phoneOtpEmpty: false
            });
            setTimeout(() => {
                this.phoneInputFocus.current.focus();
            }, 100);

        }
        else {
            if(this.state.isthirdpartylogin) {
                $(".googleSignup_popup").addClass("active");
            }
            else {
                this.setState({
                    isAction: true,
                    totpCode: "",
                    isContinue: true,
                    totpError: false,
                    totpEmpty: false
                });
                let isView = false;
                axiosInstance.get(API_HOST + "/2fa/totp/" + this.state.userId, axiosRequestWithAuth)
                    .then(resp => {
                        let info = resp.data.body;
                        if(info.error === "true") {
                            this.setState({
                                isAction: false,
                                message: "Error while doing operation totp",
                                msgType: "error"
                            });
                        }
                        else {
                            let url = "otpauth://totp/IDriveCompute%3A" + this.state.userEmail + "?secret=" + info.secretKey + "&issuer=IDriveCompute";
                            this.setState({
                                totpCode: "",
                                isAction: false,
                                isTwoFATotp: true,
                                isTwoFATotpstp1: true,
                                secretKey: info.secretKey,
                                recoveryCode: info.recoveryKey,
                                qrValue: url,
                                isQrShown: true
                            });
                        }

                    }).catch(err => {
                        this.setState({
                            isAction: false,
                            message: "Error while doing operation totp",
                            msgType: "error"
                        });
                    });
            }

        }
    };
    fromTotpLink = () => {

        this.setState({
            isAction: true,
            switchTwoFAPop: false,
            totpCode: "",
            totpEmpty: false,
            totpError: false
        });
        axiosInstance.get(API_HOST + "/2fa/totp/" + this.state.userId, axiosRequestWithAuth)
            .then(resp => {
                let info = resp.data.body;
                if(info.error === "true") {
                    this.setState({
                        isAction: false,
                        message: "Error while doing operation totp",
                        msgType: "error"
                    });
                }
                else {
                    let url = "otpauth://totp/IDriveCompute%3A" + this.state.userEmail + "?secret=" + info.secretKey + "&issuer=IDriveCompute";
                    this.setState({
                        totpCode: "",
                        isAction: false,
                        isTwoFATotp: true,
                        isTwoFATotpstp1: true,
                        secretKey: info.secretKey,
                        recoveryCode: info.recoveryKey,
                        qrValue: url
                    });
                }

            }).catch(err => {
                this.setState({
                    isAction: false,
                    message: "Error while doing operation totp",
                    msgType: "error"
                });
            });

    };
    handleInputs = (e) => {
        this.setState({
            otpErr: false,
            otpempty: false,
            phoneEmpty: false,
            phoneError: false,
            totpEmpty: false,
            totpError: false,
            phoneOtpEmpty: false,
            phoneOtpError: false
        });
        let name = e.target.name;
        let val = e.target.value;

        this.setState({
            [name]: val
        });
        if(name === "userPhone") {
            if(val.length > 0) {
                this.setState({
                    phoneError: false
                });
                if(val.length >= 7) {
                    $('#min_sev').addClass("success");
                } else {
                    $('#min_sev').removeClass("success");
                }

                if(val.length > 0 && val.length <= 20) {
                    $('#max_twe').addClass("success");
                } else {
                    $('#max_twe').removeClass("success");
                }

                const phoneNumRegex = new RegExp("^[xX0-9-+()]+$");
                if(phoneNumRegex.test(val)) {
                    $('#no_spe').addClass("success");
                } else {
                    $('#no_spe').removeClass("success");
                }
            }
            else {
                $('#min_sev').removeClass("success");
                $('#max_twe').removeClass("success");
                $('#no_spe').removeClass("success");

            }
        }
    };
    closeEmailBox = () => {
        if(this.state.clickFromEmail) {
            this.setState({
                showResult: true,
                showTimer: false,
                twofaBlock: false,
                isTwoFAEmail: false,
                message: "",
                msgType: "",
                otpempty: false,
                otpErr: false,
            });
        }
        else {
            this.setState({
                isTwoFAEmail: false,
                isCodeVerication: true,
                showTimer: false,
                message: "",
                msgType: "",
                otpempty: false,
                otpErr: false,
            });
        }

        clearInterval(this.timerId);
    };

    disableAdmintwoFA = () => {
        this.setState({
            isAction: true
        });
        axiosInstance.post(API_HOST + "/user/disableadmin2fa/" + this.state.userId, {}, axiosRequestWithAuth).then(resp => {
            this.setState({
                isAction: false
            });
            if(resp.data.body === "USER_UPDATED") {
                this.setState({
                    showResult: false,
                    isCodeVerication: true,
                    twofaBlock: true,
                    clickFromEmail: false,
                    clickFromPhone: false,
                    currentRadioButton: "twofaEmail",
                    message: "Two-factor authentication has been disabled",
                    msgType: ""
                });
            }
            else if(resp.data.body === "ACCESS_DENIED") {
                this.setState({
                    message: "Error while disabling two-factor authentication",
                    msgType: "error"
                });
            }
        })
            .catch(error => {
                this.setState({
                    isAction: false,
                    message: "Error while disabling two-factor authentication",
                    msgType: "error"
                });
            });
    };

    phoneBackButton = () => {
        if(this.state.clickFromPhone) {
            this.setState({
                showResult: true,
                showTimer: false,
                twofaBlock: false,
                isTwoFAPhoneVer1: false,
                isTwoFAPhone: false,
                message: "",
                msgType: "",
                phoneEmpty: false,
                phoneError: false,
            });
        }
        else {
            if(!this.state.showResult) {
                this.setState({
                    isCodeVerication: true,
                    isTwoFAPhoneVer1: false,
                    isTwoFAPhone: false,
                    message: "",
                    msgType: "",
                    phoneEmpty: false,
                    phoneError: false,
                });
            }
        }
    };

    phoneBackButton2 = () => {
        if(!this.state.showResult) {
            this.setState({
                isTwoFAPhoneVer1: true,
                isTwoFAPhoneVer2: false,
                showTimer: false,
                message: "",
                msgType: "",
                phoneOtpEmpty: false,
                phoneOtpError: false,
            });
            clearInterval(this.timerId);
        }
    };

    sendPhoneOtp = (event) => {
        this.setState({
            phoneEmpty: false,
            phoneError: false,
            message: "",
            msgType: "",
            disableResendPhone: false
        });
        if(this.state.userPhone.trim().length == 0) {
            this.setState({
                phoneEmpty: true
            });
            this.phoneInputFocus.current.focus();
        }
        else if(!Validate("phoneNumber", this.state.userPhone)) {
            this.setState({
                phoneError: true
            });
            this.phoneInputFocus.current.focus();
        }
        else {

            this.setState({
                isAction: true
            });
            clearInterval(this.timerId);
            var cCode = this.state.countryCode;
            let code = cCode.split("+");
            var otpDetails = {
                "email": this.state.userEmail,
                "countryCode": "+" + code[1],
                "phone": this.state.userPhone
            };
            ResourceService.sendProfileOtp(otpDetails, event).then(res => {
                //console.log(res)
                this.setState({
                    isAction: false,
                });
                if(res === undefined) {

                    this.setState({
                        message: "Phone number could not be verified. Enter a valid phone number and try again.",
                        msgType: 'error'
                    });
                    this.phoneInputFocus.current.focus();
                    if(this.recaptchaRef.current) {
                        this.recaptchaRef.current.reset();
                    }
                }
                else if(res === "TOO_MANY_CALLS") {
                    this.setState({
                        message: "Too many requests from this IP address. Try again after sometime.",
                        msgType: 'error'
                    });
                    this.phoneInputFocus.current.focus();
                    if(this.recaptchaRef.current) {
                        this.recaptchaRef.current.reset();
                    }
                }
                else {
                    clearInterval(this.timerId);
                    if(this.recaptchaRef.current) {
                        this.recaptchaRef.current.reset();
                    }
                    this.startTimer();

                    this.setState({
                        phoneOtp: "",
                        isTwoFAPhoneVer1: false,
                        isTwoFAPhoneVer2: true,
                        showTimer: true,
                        message: "Verification code has been sent",
                        msgType: ""
                    });
                    setTimeout(() => {
                        this.phoneOtpFocus.current.focus();
                    }, 100);

                }
            })
                .catch(err => {
                    this.setState({
                        isAction: false
                    });
                });


        }
    };

    resendOtpSms() {
        if(this.recaptchaRef.current) {
            this.recaptchaRef.current.execute();
        }
    }

    resendPhoneOtp = (event) => {
        this.setState({
            isAction: true,
            message: "",
            msgType: "",
            disableResendPhone: true
        });
        setTimeout(() => {
            this.setState({
                disableResendPhone: false
            });
        }, 10000);
        var cCode = this.state.countryCode;
        let code = cCode.split("+");
        var otpDetails = {
            "email": this.state.userEmail,
            "countryCode": "+" + code[1],
            "phone": this.state.userPhone
        };
        clearInterval(this.timerId);
        ResourceService.sendProfileOtp(otpDetails, event).then(res => {

            this.setState({
                isAction: false,
            });

            if(res === undefined) {

                this.setState({
                    message: "Phone number could not be verified. Enter a valid phone number and try again.",
                    msgType: 'error'
                });
                this.phoneInputFocus.current.focus();
                if(this.recaptchaRef.current) {
                    this.recaptchaRef.current.reset();
                }
            }
            else if(res === "TOO_MANY_CALLS") {
                this.setState({
                    message: "Too many requests from this IP address. Try again after sometime.",
                    msgType: 'error'
                });
                this.phoneInputFocus.current.focus();
                if(this.recaptchaRef.current) {
                    this.recaptchaRef.current.reset();
                }
            }
            else {
                clearInterval(this.timerId);
                this.startTimer();
                this.setState({
                    phoneOtp: "",
                    message: "Verification code has been sent to phone number",
                    msgType: ""
                });
            }
        });
    };

    verifyPhoneOtp = () => {
        this.setState({
            phoneOtpEmpty: false,
            phoneOtpError: false,
            message: "",
            msgType: "",
            phoneOtp: ""
        });
        if(this.state.phoneOtp.trim() == "") {
            this.setState({
                phoneOtpEmpty: true
            });
            this.phoneOtpFocus.current.focus();
            return;
        }
        else if(!Validate("otp", this.state.phoneOtp.trim()) || this.state.phoneOtp.trim().length < 6) {
            this.setState({
                phoneOtpError: true
            });
            this.phoneOtpFocus.current.focus();
            return;
        }
        else {
            this.setState({
                isAction: true
            });
            var otpDetails = {
                "otp": this.state.phoneOtp,
                "email": this.state.userEmail
            };
            ResourceService.verifyAccOtp(otpDetails, 2).then(response => {
                if(this.recaptchaRef.current) {
                    this.recaptchaRef.current.reset();
                }
                if(response?.data?.ok) {
                    axiosInstance.post(API_HOST + "/user/update-phone/" + this.state.countryCode + "/" + this.state.userId + "?phoneNo=" + this.state.userPhone, {}, axiosRequestWithAuth)
                        .then(resp => {
                            if(resp === false) {
                                this.setState({
                                    isAction: false
                                });
                            }
                            this.setState({
                                isAction: false,
                                message: "Two-factor authentication is configured",
                                msgType: "",
                                showResult: true,
                                twofaBlock: false,
                                showTimer: false,
                                isTwoFAPhone: false,
                                isTwoFAPhoneVer1: false,
                                isTwoFAPhoneVer2: false,
                                currentRadioButton: "twofaPhone"
                            });
                            clearInterval(this.timerId);
                        })
                        .catch(error => {
                            this.setState({
                                isAction: false
                            });
                        });
                } else {
                    this.setState({
                        isAction: false,
                        message: "Error while verifying OTP.",
                        msgType: "error"
                    });
                }
            }).catch(error => {
                if(error?.response?.data) {
                    let data = error.response.data;
                    if(data?.error) {
                        switch(data.error) {
                            case "invalid_credentials":
                                this.setState({
                                    isAction: false,
                                    otpErr: true,
                                    message: "Incorrect verification code. Please try again.",
                                    msgType: "error"
                                });
                                return;
                            case "exceeded_retries":
                                this.setState({
                                    isAction: false,
                                    otpErr: true,
                                    message: "Exceeded query limit. Please try after some time.",
                                    msgType: "error"
                                });
                                return;
                            default: break;
                        }
                    }
                }
                this.setState({
                    isAction: false,
                    otpErr: true,
                    message: "Error while verifying OTP",
                    msgType: "error"
                });
            });
        }
    };

    openSupportedApps = () => {
        this.setState({
            isTotpApps: true
        });
    };

    fromEmailLink = () => {
        this.setState({
            resendOtpTo: "email",
            switchTwoFAPop: false,
            clickFromEmail: true,

            isCodeVerication: false
        }, this.executeEmailCaptcha());

    };

    fromPhoneLink = () => {
        this.setState({
            resendOtpTo: "phone",
            switchTwoFAPop: false,
            clickFromPhone: true,
            showResult: false,
            isTwoFAPhone: true,
            isTwoFAPhoneVer1: true,
            isCodeVerication: false,
            twofaBlock: true
        });
        setTimeout(() => {
            this.phoneInputFocus.current.focus();
        }, 100);

    };

    checkPhoneRegex = () => {
        let val = this.state.userPhone;
        if(val != undefined) {
            if(val.length > 0) {
                this.setState({
                    phoneEmpty: false,
                    phoneError: false
                });
                if(val.length >= 7) {
                    $('#min_sev').addClass("success");
                } else {
                    $('#min_sev').removeClass("success");
                }

                if(val.length > 0 && val.length <= 20) {
                    $('#max_twe').addClass("success");
                } else {
                    $('#max_twe').removeClass("success");
                }

                const phoneNumRegex = new RegExp("^[xX0-9-+()]+$");
                if(phoneNumRegex.test(val)) {
                    $('#no_spe').addClass("success");
                } else {
                    $('#no_spe').removeClass("success");
                }
            }

        }
        else {
            $('#min_sev').removeClass("success");
            $('#max_twe').removeClass("success");
            $('#no_spe').removeClass("success");

        }
    };

    gotoTotpStp2 = () => {
        this.setState({
            isTwoFATotpstp1: false,
            isTwoFATotpstp2: true,
            isCopied: false
        });
    };

    gotoTotpStp3 = () => {
        this.setState({
            isTwoFATotpstp2: false,
            isTwoFATotpstp3: true
        });
        setTimeout(() => {
            this.totpCodeInput.current.focus();
        }, 100);
    };
    downloadRecoveryCode = (code) => {
        this.setState({
            isContinue: false
        });
        const element = document.createElement("a");
        const file = new Blob([code],
            { type: 'text/plain;charset=utf-8' });
        element.href = URL.createObjectURL(file);
        element.download = "IDriveCompute_Recovery_Code.txt";
        document.body.appendChild(element);
        element.click();
    };
    copyRecoveryCode = (event, text) => {
        this.setState({
            isContinue: false
        });
        var textField = document.createElement('textarea');
        textField.innerText = text;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();
        $(".twofa-copylink b").css("background", "rgb(255, 255, 0)");
        $(".twofa-copylink b").text("Code Copied");
        setTimeout(function () {
            $(".twofa-copylink b").css("background", "rgb(255, 255, 255)");
            $(".twofa-copylink b").text(text);
        }, 3000);
    };
    printRecoveryCode = (code) => {
    };

    verifyTotp = (event) => {

        if(this.state.totpCode.trim().length <= 0) {
            this.setState({
                totpError: false,
                totpEmpty: true
            });
        }
        else if(!Validate("otp", this.state.totpCode.trim())) {
            this.setState({
                totpError: true,
                totpEmpty: false
            });
        }
        else {
            this.setState({
                isTotpMsg: true
            });
            axiosInstance.post(API_HOST + "/2fa/totp/verify/" + this.state.userId + "?code=" + this.state.totpCode, null, axiosRequestWithAuth)
                .then(resp => {
                    if(resp.data.body) {
                        this.setState({
                            showResult: true,
                            twofaBlock: false,
                            currentRadioButton: "twofaOtp",
                            isAction: false,
                            isTwoFATotp: false,
                            isTwoFATotpstp3: false,
                            message: "Two-factor authentication is configured",
                            msgType: ""
                        });
                    }
                    else {
                        this.setState({
                            totpCode: "",
                            isAction: false,
                            totpError: true,
                            isTotpMsg: false,
                            viewTotpMessage: "",
                            message: "",
                            msgType: ""
                        });
                    }

                })
                .catch(error => {
                    if(error.message.includes('403')) {
                        this.setState({ isAction: false, isTotpMsg: false, viewTotpMessage: '', message_v2: 'Forbidden Access. Verfication terminated.', msgType_v2: 'error' });
                        return;
                    }
                    this.setState({
                        isAction: false,
                        // totpEmpty:true,
                        message_v2: 'Unable to verify TOTP. Please try again later.',
                        msgType_v2: 'error',
                        isTotpMsg: false,
                        viewTotpMessage: ""
                    });
                });
        }

    };

    viewRecoveryCode = () => {
        this.setState({
            totpCode: "",
            totpError: false,
            totpEmpty: false,
            isViewMsg: false,
            viewCodeMessage: "",
            isCopied: false
        });
        if(this.state.totpCode.trim().length <= 0) {
            this.setState({
                totpError: false,
                totpEmpty: true
            });
        }
        else if(!Validate("otp", this.state.totpCode.trim())) {
            this.setState({
                totpError: true,
                totpEmpty: false
            });
        }
        else {
            this.setState({
                isViewMsg: true
            });
            axiosInstance.get(API_HOST + "/2fa/totp/recoveryCode/" + this.state.userId + "?code=" + this.state.totpCode, axiosRequestWithAuth)
                .then(resp => {
                    if(resp.data.body != "") {
                        this.setState({
                            isCodeStp1: false,
                            isCodeStp2: true,
                            recoveryCode: resp.data.body
                        });
                    }
                    else {
                        this.setState({
                            isAction: false,
                            totpError: true
                        });
                    }

                })
                .catch(error => {
                    this.setState({
                        isAction: false,
                        totpEmpty: true
                    });
                });
        }
    };

    openRecoveryCode = () => {
        this.setState({
            isCodePopup: true, isCodeStp2: false, isCodeStp1: true, totpCode: "", totpEmpty: false, totpError: false
        });
        setTimeout(() => { this.viewCodeInput.current.focus(); }, 100);
    };

    sendPhoneOtpByCaptcha() {
        this.setState({
            isEmailCaptcha: false,
            isEmailResendCaptcha: false
        }, () => {
            if(this.recaptchaRef.current) {
                this.recaptchaRef.current.execute();
            }
        });

    }

    onRecaptchaChange = (event) => {

        if(this.state.isEmailCaptcha) {

            this.sendEmailOtp(event);
        } else if(this.state.isEmailResendCaptcha) {

            this.resendEmailOtp(event);
        } else {

            this.sendPhoneOtp(event);
        }
    };

    enterKey = (event, param) => {
        if(event.keyCode === 13) {
            if(param === "viewRecoveryCode") {
                this.viewRecoveryCode();
            }
            if(param === "tOtpCode") {
                this.verifyTotp(event);
            }
            if(param === "emailOtp") {
                this.verifyEmailOtp();
            }
            if(param === "userPhone") {
                if(this.recaptchaRef.current) {
                    this.recaptchaRef.current.execute();
                } else {
                    this.sendPhoneOtp();
                }
            }
            if(param === "phoneOtp") {
                this.verifyPhoneOtp();
            }
        }
    };
    enableSwitchPop = (param) => {

        if(param === "email") {
            this.setState({
                switchTwoFAPop: true,
                clickedLink: "email",
                clickedItem: "Email address"
            });

        }
        else if(param === "phone") {
            this.setState({
                switchTwoFAPop: true,
                clickedLink: "phone",
                clickedItem: "Phone number"
            });
        }
        else {
            if(this.state.isthirdpartylogin) {
                $(".googleSignup_popup").addClass("active");
            }
            else {
                this.setState({
                    switchTwoFAPop: true,
                    clickedLink: "totp",
                    clickedItem: "TOTP Authenticator app",
                    isQrShown: true,
                    isContinue: true
                });
            }
        }

        if(this.state.currentRadioButton === "twofaEmail") {
            this.setState({
                alreadySelectItem: "Email address"
            });
        }
        else if(this.state.currentRadioButton === "twofaOtp") {
            this.setState({
                alreadySelectItem: "TOTP Authenticator app"
            });
        }
        else {
            this.setState({
                alreadySelectItem: "Phone number"
            });
        }
    };
    expireResend = () => {
        clearInterval(this.timerId);
        this.setState({
            isResend: false
        });
        if(this.state.resendOtpTo === "email") {
            this.executeEmailCaptcha();
        }
        else {
            this.setState({
                isTwoFAPhone: true
            });
            if(this.recaptchaRef.current) {
                this.recaptchaRef.current.execute();
            } else {
                this.sendPhoneOtp();
            }
        }

    };

    enableForgetPassword() {
        $(".googleSignup_popup").removeClass("active");
        this.setState({
            isAction: true
        });
        if(this.state.isthirdpartylogin) {
            userService.resetpassword().then(resp => {
                if(resp == false) {
                    this.setState({
                        message: "An error occured. Please try again.",
                        msgType: 'error',
                        isAction: false
                    });
                }
                else {
                    this.setState({
                        message: "An email has been sent. Please check your inbox",
                        isAction: false
                    });
                }
            });
            //let href = window.location.protocol + "//" + window.location.host + "/app/forgot-password?username="+ email ;
            //let href = window.location.protocol + "//" + window.location.host + "/app/update-password/" + email + "/" + token+"?type=fromThirdPartyLogin";
            //window.open(href, '_blank');
            // this.setState({
            //     isAction: false
            // })
            // userService.generateToken(email).then( resp => {
            //     if(!resp){
            //         this.setState({
            //             message : "An error occured. Please try again.",
            //             msgType : "error",
            //             isAction: false
            //         });
            //     }
            //     else{
            //         let token = resp;
            //         let href = window.location.protocol + "//" + window.location.host + "/app/update-password/" + email + "/" + token+"?type=fromThirdPartyLogin";
            //         window.open(href, '_blank');
            //         this.setState({
            //             isAction: false
            //         });
            //     }

            //    }, function(error) {
            //     this.setState({
            //         message : "An error occured. Please try again.",
            //         msgType : "error",
            //         isAction: false
            //     });
            //    });
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="full_page_loader" style={ { display: this.state.isAction ? 'block' : 'none' } }>
                    <div className="loader_icon"></div>
                </div>
                <section className="accountModule_wrapper">
                    <div className="trusted_2fa__wrap">
                        <div className="security_ctnr">
                            <div className="twofa_ctnr">
                                <div className="accModule_head_wrap">
                                    <h2>Two-factor Authentication</h2>
                                    <p style={ { display: this.state.showResult ? "none" : "" } } className="head_info">To enable two-factor authentication for your account, you can choose one of the following methods to receive the one-time verification code.</p>

                                    <p style={ { display: this.state.showResult ? "none" : "" } }>If you choose Time-based OTP authetication, follow the on-screen steps to complete the verification process. In case you choose email or phone number, enter the received code to complete the verification.</p>
                                    <p style={ { display: this.state.showResult ? "" : "none" } }>You have enabled two-factor authentication for your account. During subsequent logins, you will need to enter your password and the one-time verification code sent to your registered email address or phone number or generated via Time-based OTP Authenticator app. <a className="know_more_link" href="https://www.idrivecompute.com/faq-two-stepverification.htm#two-step-1" target="_blank">Know more</a></p>

                                    <p style={ { display: this.state.showResult ? "none" : "" } }>Once verified and two-factor authentication enabled, you will need to enter your password and the verification code, during subsequent logins. <a className="know_more_link" href="https://www.idrivecompute.com/faq-two-stepverification.htm#two-step-1" target="_blank">Know more</a></p>
                                    <input className="common_cta_btn blue enable2fa_btn" id="disable" type="submit" value="Disable" style={ { display: this.state.showResult && this.state.roleId == 2 ? "" : "none" } } onClick={ () => this.disableAdmintwoFA() }></input>
                                    <div className="twofa_blk" style={ { display: this.state.twofaBlock ? "" : "none" } }>
                                        <div className={ this.state.isCodeVerication ? "twofa_optns optList show" : "twofa_optns optList hide" }>
                                            <h2>Choose authentication method:</h2>
                                            <label className={ this.state.currentRadioButton === "twofaEmail" ? "custom_radiobox active" : "custom_radiobox" }>
                                                <input type="radio" name="twofaOpt" checked={ this.state.currentRadioButton === "twofaEmail" } value="twofaEmail" onChange={ (e) => this.handleRadioButtons(e, "email") } /><i>Email Address</i><i>(</i> <b>{ this.state.userEmail }</b><i>)</i>
                                                <span className="checkmark"></span>
                                            </label>
                                            <label className={ this.state.currentRadioButton === "twofaPhone" ? "custom_radiobox active" : "custom_radiobox" }>
                                                <input type="radio" name="twofaOpt" checked={ this.state.currentRadioButton === "twofaPhone" } value="twofaPhone" onChange={ (e) => this.handleRadioButtons(e, "phone") } />Phone Number
                                                <span className="checkmark"></span>
                                            </label>
                                            <label className={ this.state.currentRadioButton === "twofaOtp" ? "custom_radiobox active" : "custom_radiobox" } >
                                                <input type="radio" name="twofaOpt" checked={ this.state.currentRadioButton === "twofaOtp" } value="twofaOtp" onChange={ (e) => this.handleRadioButtons(e, "totp") } />Time-based OTP authentication (<a className="support_app" id="supp_app" onClick={ () => this.openSupportedApps() }>Supported Apps</a>)
                                                <span className="checkmark"></span>
                                            </label>
                                            <div className="btn_blk">
                                                <button name="optSubmit" className="common_cta_btn blue" onClick={ (e) => this.submitRadioSelection(e) }>Confirm</button>
                                                <button style={ { display: "none" } } name="optSubmit" className="common_cta_btn transparentGrey">Cancel</button>
                                            </div>
                                        </div>
                                        <div className={ this.state.isTwoFAEmail ? "twofa_optns twofa_Email show" : "twofa_optns twofa_Email hide" }>
                                            <div className="email_input_blk">
                                                <label>Enter the verification code received via your registered email address</label>
                                                <input type="password" maxLength="6" name="emailOtp" value={ this.state.emailOtp } ref={ this.emailOtpInput } onKeyDown={ (e) => this.enterKey(e, "emailOtp") } onChange={ (e) => this.handleInputs(e) } />
                                                <button name="optSubmit" className="common_cta_btn blue" onClick={ () => { this.verifyEmailOtp(); } }>Verify & Enable</button>
                                                <button name="optSubmit" className="common_cta_btn transparentGrey" onClick={ () => this.closeEmailBox() }>Back</button>
                                                <span className="err_msg" style={ { display: this.state.otpempty ? "block" : "none" } }>Verification code cannot be blank</span>
                                                <span className="err_msg" style={ { display: this.state.otpErr ? "block" : "none" } }>Enter a valid verification code</span>
                                            </div>
                                            <p>If you have not received your code, <a id="resend_btn" href="javascript:;" className={ this.state.disableResendEmail ? "disabled" : "" } onClick={ () => { this.executeResendEmailCaptcha(); } }>click here to resend</a></p>

                                        </div>
                                        <div className="email_verfy__blk" style={ { display: this.state.isResend ? "" : "none" } }>
                                            <h2>Your verification code has expired!</h2>
                                            <input className="common_cta_btn blue" type="submit" value="Resend Now!" onClick={ () => this.expireResend() } />
                                        </div>
                                        <div className={ this.state.isTwoFAPhone ? "twofa_optns twofa_phone show" : "twofa_optns twofa_phone hide" }>
                                            <div className={ this.state.isTwoFAPhoneVer1 ? "phone_verification1 show" : "phone_verification1 hide" }>
                                                <h2>Get one-time verification code via text message</h2>
                                                <p>Enter your phone number and click 'Send Code'. SMS charges may apply</p>
                                                <div className="custom_select_box coutry_code_wrap" >
                                                    <select name="countryCode" id="countryCode" value={ this.state.countryCode } onChange={ (e) => this.handleInputs(e) }>
                                                        <option value="" style={ { display: "none" } } disabled={ true }>Select the country code</option>
                                                        <option value="USA +1">USA +1</option>
                                                        <option value="Afghanistan +93">Afghanistan +93 </option>
                                                        <option value="Albania +355">Albania +355 </option>
                                                        <option value="Algeria +213">Algeria +213 </option>
                                                        <option value="American Samoa +684">American Samoa +684 </option>
                                                        <option value="Andorra +376">Andorra +376 </option>
                                                        <option value="Angola +244">Angola +244 </option>
                                                        <option value="Anguilla +1-264">Anguilla +1-264 </option>
                                                        <option value="Antarctica +672">Antarctica +672 </option>
                                                        <option value="Antigua and Barbuda +1-268">Antigua and Barbuda +1-268 </option>
                                                        <option value="Argentina +54">Argentina +54 </option>
                                                        <option value="Armenia +374">Armenia +374 </option>
                                                        <option value="Aruba +297">Aruba +297 </option>
                                                        <option value="Australia +61">Australia +61 </option>
                                                        <option value="Austria +43">Austria +43 </option>
                                                        <option value="Azerbaijan +994">Azerbaijan +994 </option>
                                                        <option value="Bahamas +1-242">Bahamas +1-242 </option>
                                                        <option value="Bahrain +973">Bahrain +973 </option>
                                                        <option value="Bangladesh +880">Bangladesh +880 </option>
                                                        <option value="Barbados +1-246">Barbados +1-246 </option>
                                                        <option value="Belarus +375">Belarus +375 </option>
                                                        <option value="Belgium +32">Belgium +32 </option>
                                                        <option value="Belize +501">Belize +501 </option>
                                                        <option value="Benin +229">Benin +229 </option>
                                                        <option value="Bermuda +1-441">Bermuda +1-441 </option>
                                                        <option value="Bhutan +975">Bhutan +975 </option>
                                                        <option value="Bolivia +591">Bolivia +591 </option>
                                                        <option value="Bosnia-Herzegovina +387">Bosnia-Herzegovina +387 </option>
                                                        <option value="Botswana +267">Botswana +267 </option>
                                                        <option value="Brazil +55">Brazil + 55 </option>
                                                        <option value="Brunei Darussalam +673">Brunei Darussalam +673 </option>
                                                        <option value="Bulgaria +359">Bulgaria +359 </option>
                                                        <option value="Burkina Faso +226">Burkina Faso +226 </option>
                                                        <option value="Burundi +257">Burundi +257 </option>
                                                        <option value="Cambodia +855">Cambodia +855 </option>
                                                        <option value="Cameroon +237">Cameroon +237 </option>
                                                        <option value="Canada +1">Canada +1 </option>
                                                        <option value="Cape Verde +238">Cape Verde +238 </option>
                                                        <option value="Cayman Islands +1-345">Cayman Islands +1-345 </option>
                                                        <option value="Central African Republic +236">Central African Republic +236 </option>
                                                        <option value="Chad +235">Chad +235 </option>
                                                        <option value="Chile +56">Chile +56 </option>
                                                        <option value="China +86">China +86 </option>
                                                        <option value="Christmas Island +61">Christmas Island +61 </option>
                                                        <option value="Cocos (Keeling) Islands +61">Cocos (Keeling) Islands +61 </option>
                                                        <option value="Colombia +57">Colombia +57 </option>
                                                        <option value="Comoros +269">Comoros +269 </option>
                                                        <option value="Congo +242">Congo +242 </option>
                                                        <option value="Congo, Dem. Republic +243">Congo, Dem. Republic +243 </option>
                                                        <option value="Cook Islands +682">Cook Islands +682 </option>
                                                        <option value="Costa Rica +506">Costa Rica +506 </option>
                                                        <option value="Croatia +385">Croatia +385 </option>
                                                        <option value="Cuba +53">Cuba +53 </option>
                                                        <option value="Cyprus +357">Cyprus +357 </option>
                                                        <option value="Czech Rep. +420">Czech Rep. +420 </option>
                                                        <option value="Denmark +45">Denmark +45 </option>
                                                        <option value="Djibouti +253">Djibouti +253 </option>
                                                        <option value="Dominica +1-767">Dominica +1-767 </option>
                                                        <option value="Dominican Republic +809">Dominican Republic +809 </option>
                                                        <option value="Ecuador +593">Ecuador +593 </option>
                                                        <option value="Egypt +20">Egypt +20 </option>
                                                        <option value="El Salvador +503">El Salvador +503 </option>
                                                        <option value="Equatorial Guinea +240">Equatorial Guinea +240 </option>
                                                        <option value="Eritrea +291">Eritrea +291 </option>
                                                        <option value="Estonia +372">Estonia +372 </option>
                                                        <option value="Ethiopia +251">Ethiopia +251 </option>
                                                        <option value="Falkland Islands (Malvinas) +500">Falkland Islands (Malvinas) +500 </option>
                                                        <option value="Faroe Islands +298">Faroe Islands +298 </option>
                                                        <option value="Fiji +679">Fiji +679 </option>
                                                        <option value="Finland +358">Finland +358 </option>
                                                        <option value="France +33">France +33 </option>
                                                        <option value="French Guiana +594">French Guiana +594 </option>
                                                        <option value="Gabon +241">Gabon +241 </option>
                                                        <option value="Gambia +220">Gambia +220 </option>
                                                        <option value="Georgia +995">Georgia +995 </option>
                                                        <option value="Germany +49">Germany +49 </option>
                                                        <option value="Ghana +233">Ghana +233 </option>
                                                        <option value="Gibraltar +350">Gibraltar +350 </option>
                                                        <option value="Great Britain +44">Great Britain +44 </option>
                                                        <option value="Greece +30">Greece +30 </option>
                                                        <option value="Greenland +299">Greenland +299 </option>
                                                        <option value="Grenada +1-473">Grenada +1-473 </option>
                                                        <option value="Guadeloupe (French) +590">Guadeloupe (French) +590 </option>
                                                        <option value="Guam (USA) +1-671">Guam (USA) +1-671 </option>
                                                        <option value="Guatemala +502">Guatemala +502 </option>
                                                        <option value="Guinea +224">Guinea +224 </option>
                                                        <option value="Guinea Bissau +245">Guinea Bissau +245 </option>
                                                        <option value="Guyana +592">Guyana +592 </option>
                                                        <option value="Haiti +509">Haiti +509 </option>
                                                        <option value="Honduras +504">Honduras +504 </option>
                                                        <option value="Hong Kong +852">Hong Kong +852 </option>
                                                        <option value="Hungary +36">Hungary +36 </option>
                                                        <option value="Iceland +354">Iceland +354 </option>
                                                        <option value="India +91">India +91 </option>
                                                        <option value="Indonesia +62">Indonesia +62 </option>
                                                        <option value="Iran +98">Iran +98 </option>
                                                        <option value="Iraq +964">Iraq +964 </option>
                                                        <option value="Ireland +353">Ireland +353 </option>
                                                        <option value="Israel +972">Israel +972 </option>
                                                        <option value="Italy +39">Italy +39 </option>
                                                        <option value="Ivory Coast +225">Ivory Coast +225 </option>
                                                        <option value="Jamaica +1-876">Jamaica +1-876 </option>
                                                        <option value="Japan +81">Japan +81 </option>
                                                        <option value="Jordan +962">Jordan +962 </option>
                                                        <option value="Kazakhstan +7">Kazakhstan +7 </option>
                                                        <option value="Kenya +254">Kenya +254 </option>
                                                        <option value="Kiribati +686">Kiribati +686 </option>
                                                        <option value="Korea-North +850">Korea-North +850 </option>
                                                        <option value="Korea-South +82">Korea-South +82 </option>
                                                        <option value="Kuwait +965">Kuwait +965 </option>
                                                        <option value="Kyrgyzstan +996">Kyrgyzstan +996 </option>
                                                        <option value="Laos +856">Laos +856 </option>
                                                        <option value="Latvia +371">Latvia +371 </option>
                                                        <option value="Lebanon +961">Lebanon +961 </option>
                                                        <option value="Lesotho +266">Lesotho +266 </option>
                                                        <option value="Liberia +231">Liberia +231 </option>
                                                        <option value="Libya +218">Libya +218 </option>
                                                        <option value="Liechtenstein +423">Liechtenstein +423 </option>
                                                        <option value="Lithuania +370">Lithuania +370 </option>
                                                        <option value="Luxembourg +352">Luxembourg +352 </option>
                                                        <option value="Macau +853">Macau +853 </option>
                                                        <option value="Macedonia +389">Macedonia +389 </option>
                                                        <option value="Madagascar +261">Madagascar +261 </option>
                                                        <option value="Malawi +265">Malawi +265 </option>
                                                        <option value="Malaysia +60">Malaysia +60 </option>
                                                        <option value="Maldives +960">Maldives +960 </option>
                                                        <option value="Mali +223">Mali +223 </option>
                                                        <option value="Malta +356">Malta +356 </option>
                                                        <option value="Marshall Islands +692">Marshall Islands +692 </option>
                                                        <option value="Martinique (French) +596">Martinique (French) +596 </option>
                                                        <option value="Mauritania +222">Mauritania +222 </option>
                                                        <option value="Mauritius +230">Mauritius +230 </option>
                                                        <option value="Mayotte +269">Mayotte +269 </option>
                                                        <option value="Mexico +52">Mexico +52 </option>
                                                        <option value="Micronesia +691">Micronesia +691 </option>
                                                        <option value="Moldova +373">Moldova +373 </option>
                                                        <option value="Monaco +377">Monaco +377 </option>
                                                        <option value="Mongolia +976">Mongolia +976 </option>
                                                        <option value="Montenegro +382">Montenegro +382 </option>
                                                        <option value="Montserrat +1-664">Montserrat +1-664 </option>
                                                        <option value="Morocco +212">Morocco +212 </option>
                                                        <option value="Mozambique +258">Mozambique +258 </option>
                                                        <option value="Myanmar +95">Myanmar +95 </option>
                                                        <option value="Namibia +264">Namibia +264 </option>
                                                        <option value="Nauru +674">Nauru +674 </option>
                                                        <option value="Nepal +977">Nepal +977 </option>
                                                        <option value="Netherlands +31">Netherlands +31 </option>
                                                        <option value="Netherlands Antilles +599">Netherlands Antilles +599 </option>
                                                        <option value="New Caledonia (French) +687">New Caledonia (French) +687 </option>
                                                        <option value="New Zealand +64">New Zealand +64 </option>
                                                        <option value="Nicaragua +505">Nicaragua +505 </option>
                                                        <option value="Niger +227">Niger +227 </option>
                                                        <option value="Nigeria +234">Nigeria +234 </option>
                                                        <option value="Niue +683">Niue +683 </option>
                                                        <option value="Norfolk Island +672">Norfolk Island +672 </option>
                                                        <option value="Northern Mariana Islands +670">Northern Mariana Islands +670 </option>
                                                        <option value="Norway +47">Norway +47 </option>
                                                        <option value="Oman +968">Oman +968 </option>
                                                        <option value="Pakistan +92">Pakistan +92 </option>
                                                        <option value="Palau +680">Palau +680 </option>
                                                        <option value="Panama +507">Panama +507 </option>
                                                        <option value="Papua New Guinea +675">Papua New Guinea +675 </option>
                                                        <option value="Paraguay +595">Paraguay +595 </option>
                                                        <option value="Peru +51">Peru +51 </option>
                                                        <option value="Philippines +63">Philippines +63 </option>
                                                        <option value="Poland +48">Poland +48 </option>
                                                        <option value="Polynesia (French) +689">Polynesia (French) +689 </option>
                                                        <option value="Portugal +351">Portugal +351 </option>
                                                        <option value="Puerto Rico +1-787">Puerto Rico +1-787 </option>
                                                        <option value="Qatar +974">Qatar +974 </option>
                                                        <option value="Reunion (French) +262">Reunion (French) +262 </option>
                                                        <option value="Romania +40">Romania +40 </option>
                                                        <option value="Russia +7">Russia +7 </option>
                                                        <option value="Rwanda +250">Rwanda +250 </option>
                                                        <option value="Saint Helena +290">Saint Helena +290 </option>
                                                        <option value="Saint Kitts &amp; Nevis Anguilla +1-869">Saint Kitts &amp; Nevis Anguilla +1-869 </option>
                                                        <option value="Saint Lucia +1-758">Saint Lucia +1-758 </option>
                                                        <option value="Saint Pierre and Miquelon +508">Saint Pierre and Miquelon +508 </option>
                                                        <option value="Saint Vincent &amp; Grenadines +1-784">Saint Vincent &amp; Grenadines +1-784 </option>
                                                        <option value="Samoa +684">Samoa +684 </option>
                                                        <option value="San Marino +378">San Marino +378 </option>
                                                        <option value="Sao Tome and Principe +239">Sao Tome and Principe +239 </option>
                                                        <option value="Saudi Arabia +966">Saudi Arabia +966 </option>
                                                        <option value="Senegal +221">Senegal +221 </option>
                                                        <option value="Serbia +381">Serbia +381 </option>
                                                        <option value="Seychelles +248">Seychelles +248 </option>
                                                        <option value="Sierra Leone +232">Sierra Leone +232 </option>
                                                        <option value="Singapore +65">Singapore +65 </option>
                                                        <option value="Slovakia +421">Slovakia +421 </option>
                                                        <option value="Slovenia +386">Slovenia +386 </option>
                                                        <option value="Solomon Islands +677">Solomon Islands +677 </option>
                                                        <option value="Somalia +252">Somalia +252 </option>
                                                        <option value="South Africa +27">South Africa +27 </option>
                                                        <option value="Spain +34">Spain +34 </option>
                                                        <option value="Sri Lanka +94">Sri Lanka +94 </option>
                                                        <option value="Sudan +249">Sudan +249 </option>
                                                        <option value="Suriname +597">Suriname +597 </option>
                                                        <option value="Swaziland +268">Swaziland +268 </option>
                                                        <option value="Sweden +46">Sweden +46 </option>
                                                        <option value="Switzerland +41">Switzerland +41 </option>
                                                        <option value="Syria +963">Syria +963 </option>
                                                        <option value="Taiwan +886">Taiwan +886 </option>
                                                        <option value="Tajikistan +992">Tajikistan +992 </option>
                                                        <option value="Tanzania +255">Tanzania +255 </option>
                                                        <option value="Thailand +66">Thailand +66 </option>
                                                        <option value="Togo +228">Togo +228 </option>
                                                        <option value="Tokelau +690">Tokelau +690 </option>
                                                        <option value="Tonga +676">Tonga +676 </option>
                                                        <option value="Trinidad and Tobago +1-868">Trinidad and Tobago +1-868 </option>
                                                        <option value="Tunisia +216">Tunisia +216 </option>
                                                        <option value="Turkey +90">Turkey +90 </option>
                                                        <option value="Turkmenistan +993">Turkmenistan +993 </option>
                                                        <option value="Turks and Caicos Islands +1-649">Turks and Caicos Islands +1-649 </option>
                                                        <option value="Tuvalu +688">Tuvalu +688 </option>
                                                        <option value="U.K. +44">U.K. +44 </option>
                                                        <option value="Uganda +256">Uganda +256 </option>
                                                        <option value="Ukraine +380">Ukraine +380 </option>
                                                        <option value="United Arab Emirates +971">United Arab Emirates +971 </option>
                                                        <option value="Uruguay +598">Uruguay +598 </option>
                                                        <option value="Uzbekistan +998">Uzbekistan +998 </option>
                                                        <option value="Vanuatu +678">Vanuatu +678 </option>
                                                        <option value="Vatican +39">Vatican +39 </option>
                                                        <option value="Venezuela +58">Venezuela +58 </option>
                                                        <option value="Vietnam +84">Vietnam +84 </option>
                                                        <option value="Virgin Islands (British) +1-28284">Virgin Islands (British) +1-28484 </option>
                                                        <option value="Virgin Islands (USA) +1-34040">Virgin Islands (USA) +1-34040 </option>
                                                        <option value="Wallis and Futuna Islands +681">Wallis and Futuna Islands +681 </option>
                                                        <option value="Yemen +967">Yemen +967 </option>
                                                        <option value="Zambia +260">Zambia +260 </option>
                                                        <option value="Zimbabwe +263">Zimbabwe +263 </option>
                                                    </select>
                                                </div>
                                                <div className="phoneinput_blk">
                                                    <input type="text" name="userPhone" maxLength="20" value={ this.state.userPhone } ref={ this.phoneInputFocus } onKeyDown={ (e) => this.enterKey(e, "userPhone") } onFocus={ (e) => this.checkPhoneRegex() } onChange={ (e) => this.handleInputs(e) } />
                                                    <div className="id-tooltip id-tooltip-topright">
                                                        <p className="id-tooltip-note">Use atleast:</p>
                                                        <ul>
                                                            <li id="min_sev">minimum of 7 characters </li>
                                                            <li id="max_twe">maximum of 20 characters</li>
                                                            <li id="no_spe">only characters 0-9 x X - + ()</li>
                                                        </ul>
                                                    </div>

                                                </div>
                                                <span className="err_msg" style={ { display: this.state.phoneEmpty ? "block" : "none" } }>Phone number cannot be blank</span>
                                                <span className="err_msg" style={ { display: this.state.phoneError ? "block" : "none" } }>Enter a valid phone number</span>
                                                <p className="form-note"><b>Note:</b> This number will be updated in your account and used to deliver all account-related notifications.</p>
                                                <div className="btn_blk">
                                                    <button name="optSubmit" className="common_cta_btn blue" onClick={ () => this.sendPhoneOtpByCaptcha() }>Send Code</button>
                                                    <button name="optSubmit" className="common_cta_btn transparentGrey" onClick={ () => this.phoneBackButton() }>Back</button>
                                                </div>

                                            </div>
                                            <div className={ this.state.isTwoFAPhoneVer2 ? "phone_verification2 show" : "phone_verification2 hide" }>
                                                <label>Enter the verification code sent to your registered mobile number { splitcountryCode(this.state.countryCode) } { this.state.userPhone }</label>
                                                <input type="password" maxLength="6" name="phoneOtp" value={ this.state.phoneOtp } ref={ this.phoneOtpFocus } onKeyDown={ (e) => this.enterKey(e, "phoneOtp") } onChange={ (e) => this.handleInputs(e) } />

                                                <button name="optSubmit" className="common_cta_btn blue" onClick={ () => this.verifyPhoneOtp() }>Verify & Enable</button>
                                                <button name="optSubmit" className="common_cta_btn transparentGrey" onClick={ () => this.phoneBackButton2() }>Back</button>
                                                <span className="err_msg" style={ { display: this.state.phoneOtpEmpty ? "block" : "none" } }>Verification code cannot be blank</span>
                                                <span className="err_msg" style={ { display: this.state.phoneOtpError ? "block" : "none" } }>Enter a valid verification code</span>
                                                <span className="err-msg"></span>
                                                <p>If you have not received your code <a href="javascript:;" className={ this.state.disableResendPhone ? "disabled" : "" } onClick={ () => this.resendOtpSms() }>click here to resend</a></p>
                                            </div>
                                        </div>

                                    </div>
                                    <p className="idcmp-code-timer" id="otp_timer" style={ { display: this.state.showTimer && !this.state.isResend ? "" : "none" } }>Your verification code will expire in <b>04:13</b> Minutes</p>
                                    <div className="twofa_blk" style={ { display: this.state.showResult ? "" : "none" } }>
                                        <div className="twofa-vrcode-wrap twofa-switch-email-msg" style={ { display: this.state.currentRadioButton === "twofaEmail" ? "" : "none" } }>
                                            <p className="twofa-vrcode-info">Verification code will be sent to </p>
                                            <p className="twofa-vrcode-link">{ this.state.userEmail }</p>
                                        </div>

                                        <div className="twofa-vrcode-wrap twofa-switch-totp-msg " style={ { display: this.state.currentRadioButton === "twofaOtp" ? "" : "none" } }>
                                            <p className="twofa-vrcode-info">Verification code will be generated on the Time-based OTP Authenticator app </p>
                                            <a className="twofa-vrcode-link" href="javascript:;" onClick={ () => this.openRecoveryCode() }>View recovery code</a>
                                        </div>

                                        <div className="twofa-vrcode-wrap twofa-switch-mobile-msg " style={ { display: this.state.currentRadioButton === "twofaPhone" ? "" : "none" } }>
                                            <p className="twofa-vrcode-info">Verification code will be sent to </p>
                                            <p className="twofa-vrcode-link" id="phone-link">{ splitcountryCode(this.state.countryCode) } { this.state.userPhone }</p>
                                        </div>
                                        <h4 className="change-2fa-title">Change verification method:</h4>
                                        <p className={ this.state.currentRadioButton !== "twofaEmail" ? "twofa-p" : "twofa-hide" }>
                                            <a className="twofa-switch-email-link " href="javascript:;" onClick={ () => this.enableSwitchPop("email") }>Verify code via email address</a>
                                        </p>

                                        <p className={ this.state.currentRadioButton !== "twofaOtp" ? "twofa-p" : "twofa-hide" }>
                                            <a className="twofa-switch-totp-link " href="javascript:;" onClick={ () => this.enableSwitchPop("totp") }>Verify code via Time-based OTP Authenticator app </a>
                                            <span className="twofa-supportedwrap" > (<a className="support_app" id="supp_app" onClick={ () => this.openSupportedApps() }>Supported Apps</a>)</span>
                                        </p>

                                        <p className={ this.state.currentRadioButton !== "twofaPhone" ? "twofa-p" : "twofa-hide" }>
                                            <a className="twofa-switch-mobile-link" href="javascript:;" onClick={ () => this.enableSwitchPop("phone") }>Verify code via phone number</a>
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    { (this.state.message != '') ? <CommonMessage message={ this.state.message } msgType={ this.state.msgType } handler={ () => this.setState({ message: '', msgType: '' }) } /> : null }
                </section>
                <div className={ this.state.isTwoFATotp ? "main_popup timebasedOtp_popup active" : "main_popup timebasedOtp_popup" }>
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap">
                                <span className="close_icon" onClick={ () => this.setState({ isTwoFATotp: false, isTwoFATotpstp1: false, isTwoFATotpstp2: false, isTwoFATotpstp3: false }) }></span>
                                <div className="popup_body">
                                    <div className="stp1" style={ { display: this.state.isTwoFATotpstp1 ? "" : "none" } }>
                                        <div className="popup_header">
                                            <div className="sub_title">Enable Time-based OTP authentication</div>
                                        </div>
                                        <div className="steps_innerCtnr">
                                            <p>Generate one-time codes via Time-based OTP Authenticator app for validating your sign in to IDrive Compute for stronger security.</p>
                                            <p className="etb_otp_stpes">Steps to configure Time-based OTP authentication:</p>
                                            <ul>
                                                <li>1. Install and launch the Time-based OTP Authenticator app on your mobile device.</li>
                                                <li>2. Add a new time-based key.</li>
                                                <li className="scanOpt" style={ { display: this.state.isQrShown ? "" : "none" } }>3. Scan the QR code below or <a href="javascript:;" className="manual_key" onClick={ () => { this.setState({ isQrShown: false }); } } title="enter key manually">enter key manually.</a></li>
                                                <li className="keyOpt" style={ { display: this.state.isQrShown ? "none" : "" } }>3. Enter the key below or <a href="javascript:;" className="scan_qr" onClick={ () => { this.setState({ isQrShown: true }); } } title="scan the QR code">scan the QR code.</a> </li>
                                            </ul>
                                            <div className="qrcode_blk">
                                                { this.state.isQrShown ?
                                                    <QRCode
                                                        id="qr-gen"
                                                        value={ this.state.qrValue }
                                                        size={ 120 }
                                                        level={ "H" }
                                                        includeMargin={ true }
                                                    /> :
                                                    <b className="totp_key">{ this.state.secretKey }</b>
                                                }
                                            </div>
                                        </div>
                                        <div className="popup_footer">
                                            <div className="popup_footer__btns button_inverse">
                                                <button className="btn btn_cancel" onClick={ () => this.setState({ isTwoFATotp: false }) }>Cancel</button>
                                                <button className="btn blue showCode" onClick={ () => this.gotoTotpStp2() }>Next</button>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="stp2" style={ { display: this.state.isTwoFATotpstp2 ? "" : "none" } }>
                                        <div className="popup_header">
                                            <div className="sub_title">Enable Time-based OTP authentication</div>
                                        </div>
                                        <div className="steps_innerCtnr">
                                            <p>You will require this recovery code to deactivate two-factor authentication for your account, in case you lose access to your mobile device where the Time-based OTP Authenticator app is installed.</p>
                                            <p>Store the following recovery code safely before activating two-factor authenticatio. Copy/print/download the code to proceed.</p>
                                            <div className="twofa-copylink"><b> { this.state.recoveryCode } </b><button className="copy_btn" onClick={ (e) => this.copyRecoveryCode(e, this.state.recoveryCode) }>{ this.state.isCopied ? "Code Copied" : "Copy Code" }</button></div>
                                            <div className="twofa-dowprint">
                                                <a href="#" className="dwnld-btn" onClick={ (e) => { this.downloadRecoveryCode(this.state.recoveryCode); e.preventDefault(); } }>Download</a>
                                                <Link to={ { pathname: "/print-recovery/" + this.state.userId } } target={ "_blank" }><a className="prnt-btn" onClick={ () => this.setState({ isContinue: false }) }>Print</a></Link>
                                            </div>
                                        </div>
                                        <div className="popup_footer">
                                            <div className="popup_footer__btns button_inverse">
                                                <button className="btn btn-cancel hideCode" onClick={ () => { this.setState({ isTwoFATotpstp2: false, isTwoFATotpstp1: true }); } }>Back</button>
                                                <button className={ this.state.isContinue ? "btn blue showOtptext disabled" : "btn blue showOtptext" } onClick={ () => this.gotoTotpStp3() } disabled={ this.state.isContinue }>Continue</button>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="stp3" style={ { display: this.state.isTwoFATotpstp3 ? "" : "none" } }>
                                        <div className="popup_header">
                                            <div className="sub_title">Time-based OTP authentication</div>
                                        </div>
                                        <div className="steps_innerCtnr">
                                            <p className="resend_msg" style={ { display: this.state.isTotpMsg ? "none" : "none" } }>{ this.state.viewTotpMessage }</p>
                                            <p>Enter the one-time code generated by the Time-based OTP Authenticator app in your mobile device, to enable two-factor authentication.</p>
                                            <div className="twofa-inputgroup">
                                                <label htmlFor="">Enter one-time code</label>
                                                <input type="password" value={ this.state.totpCode } maxLength="6" className="id-frm-ctrl" ref={ this.totpCodeInput } name="totpCode" onKeyDown={ (e) => this.enterKey(e, "tOtpCode") } onChange={ (e) => this.handleInputs(e) } />
                                                <span className="err_msg" style={ { display: this.state.totpEmpty ? "block" : "none" } }>Verification code cannot be blank</span>
                                                <span className="err_msg" style={ { display: this.state.totpError ? "block" : "none" } }>Enter a valid verification code</span>
                                            </div>
                                        </div>
                                        <div className="popup_footer">
                                            <div className="popup_footer__btns button_inverse">
                                                <button className="btn btn_cancel" onClick={ () => this.setState({ isTwoFATotpstp3: false, isTwoFATotp: false }) }>Cancel</button>
                                                <button className="btn blue" onClick={ (e) => this.verifyTotp(e) } disabled={ this.state.isTotpMsg }>Enable</button>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    { (this.state.message_v2 != '') ? <CommonMessage message={ this.state.message_v2 } msgType={ this.state.msgType_v2 } handler={ () => this.setState({ message_v2: '', msgType_v2: '' }) } /> : null }
                </div>
                <div className={ this.state.isCodePopup ? "main_popup recoveryCode_popup active" : "main_popup recoveryCode_popup" }>
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap">
                                <span className="close_icon" onClick={ () => this.setState({ isCodePopup: false, isCodeStp1: false }) }></span>
                                <div className="popup_body">
                                    <div className="stp1" style={ { display: this.state.isCodeStp1 ? "" : "none" } }>
                                        <div className="popup_header">
                                            <div className="sub_title">Recovery Code</div>
                                        </div>
                                        <div className="steps_innerCtnr">
                                            <p className="resend_msg" style={ { display: this.state.isViewMsg ? "none" : "none" } }>{ this.state.viewCodeMessage }</p>
                                            <p>Enter the one-time code generated on the Time-based OTP Authenticator app in your mobile device, to view recovery code</p>
                                            <div className="twofa-inputgroup">
                                                <label for="">Enter one-time code</label>
                                                <input type="password" value={ this.state.totpCode } className="id-frm-ctrl" ref={ this.viewCodeInput } name="totpCode" onKeyDown={ (e) => this.enterKey(e, "viewRecoveryCode") } onChange={ (e) => this.handleInputs(e) } />
                                                <span className="err_msg" style={ { display: this.state.totpEmpty ? "block" : "none" } }>Verification code cannot be blank</span>
                                                <span className="err_msg" style={ { display: this.state.totpError ? "block" : "none" } }>Enter a valid verification code</span>
                                            </div>
                                        </div>
                                        <div className="popup_footer">
                                            <div className="popup_footer__btns button_inverse">
                                                <button className="btn btn_cancel" onClick={ () => this.setState({ isCodePopup: false, isCodeStp1: false }) }>Cancel</button>
                                                <button className="btn blue viewVCode" onClick={ () => this.viewRecoveryCode() }>View</button>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="stp2" style={ { display: this.state.isCodeStp2 ? "" : "none" } }>
                                        <div className="popup_header">
                                            <div className="sub_title">Recovery code</div>
                                        </div>
                                        <div className="steps_innerCtnr">
                                            <p>You will require this recovery code to deactivate two-factor authentication for your account, in case you lose access to your mobile device where the Time-based OTP Authenticator app is installed.</p>
                                            <p>Store the following recovery code safely before activating two-factor authentication. Copy/print/download the code to proceed.</p>
                                            <div className="twofa-copylink"><b> { this.state.recoveryCode } </b><button className="copy_btn" onClick={ (e) => this.copyRecoveryCode(e, this.state.recoveryCode) }>{ this.state.isCopied ? "Code Copied" : "Copy Code" }</button></div>
                                            <div className="twofa-dowprint">
                                                <a href="javascript:;" className="dwnld-btn" onClick={ () => this.downloadRecoveryCode(this.state.recoveryCode) }>Download</a>
                                                <Link to={ { pathname: "/print-recovery/" + this.state.userId } } target={ "_blank" }><a className="prnt-btn" >Print</a></Link>
                                            </div>
                                        </div>
                                        <div className="popup_footer">
                                            <div className="popup_footer__btns">
                                                <button className="btn btn_cancel" onClick={ () => this.setState({ isCodePopup: false, isCodeStp1: false, isCodeStp2: false }) }>Close</button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={ this.state.switchTwoFAPop ? "main_popup switch2fa_popup active" : "main_popup switch2fa_popup" }>
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap">
                                <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => this.setState({ switchTwoFAPop: false }) }></span>
                                <div className="popup_body">
                                    <div className="popup_header">
                                        <div className="sub_title">Two-factor Authentication</div>
                                    </div>
                                    <div className="steps_innerCtnr">
                                        <p>If you chose to receive verification code via { this.state.clickedItem }, you will henceforth not receive any code on your { this.state.alreadySelectItem }.</p>
                                        <p style={ { display: "none" } }>If you chose to receive verification code via Time-based OTP Authenticator app, you will henceforth not receive any code on your Email address.</p>
                                        <p style={ { display: "none" } }>If you chose to receive verification code via phone number, you will henceforth not receive any code on your Email address.</p>
                                        <p>Do you wish to proceed?</p>
                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns button_inverse">
                                            <button className="btn btn_cancel" onClick={ () => this.setState({ switchTwoFAPop: false }) }>Cancel</button>
                                            <button className="btn blue " onClick={ () => {
                                                this.state.clickedLink === "email" ?
                                                    this.fromEmailLink() : this.state.clickedLink === "phone" ? this.fromPhoneLink()
                                                        : this.fromTotpLink();
                                            } }>Ok</button>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className={ this.state.isTotpApps ? "main_popup totpSupport_popup active" : "main_popup totpSupport_popup" }>
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon" onClick={ () => { this.setState({ isTotpApps: false }); } }></span>
                                <div className="popup_header">
                                    <div className="sub_title">TOTP Supported Apps</div>
                                </div>
                                <div className="popup_body">
                                    <p>You can choose from any of the available apps for your mobile platform. Any two-factor authentication app that supports time-based one-time protocol or is compatible with Google Authenticator can also be used.</p>
                                    <ul className="totpSupport_list">
                                        <li>
                                            <a href="https://support.google.com/accounts/answer/1066447?hl=en" target="_blank">Google Authenticator</a> (Android/iPhone/BlackBerry)</li>
                                        <li>
                                            <a href="http://guide.duosecurity.com/third-party-accounts" target="_blank">Duo Mobile</a> (Android/iPhone)</li>
                                        <li>
                                            <a href="https://www.microsoft.com/en-us/store/apps/authenticator/9wzdncrfj3rj" target="_blank">Microsoft Authenticator</a> (Android/iPhone/Windows Phone 7)</li>
                                        <li>
                                            <a href="https://play.google.com/store/apps/details?id=com.okta.android.auth" target="_blank">Okta Verify</a> (Android/iPhone)</li>
                                        <li>
                                            <a href="https://authy.com/features/setup/" target="_blank">Authy</a> (Android/iPhone)</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main_popup googleSignup_popup">
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon" dataToggle="tooltip" title="" dataOriginalTitle="Close" onClick={ () => { $(".googleSignup_popup").removeClass("active"); } }></span>
                                <div className="popup_header">
                                    <div className="sub_title">Action required</div>
                                </div>
                                <div className="popup_body">
                                    <div className="common_txtBox_row">
                                        <div className="acc-impMsg">
                                            <p>You are currently using { this.state.thirdPartyName } Sign-in, which does not require a password.<br />For security reasons, activating two-factor authentication via TOTP apps requires setting up a password for your account. Once the password is updated, you can use  { this.state.thirdPartyName } Sign-in or your email address and password for logging in.</p>
                                        </div>
                                        <p className="resetTitle"><b>A link with instructions to set a password will be sent to the email address provided here.</b></p>
                                        <span className="reset_info">You may need to check your spam folder or add <strong>support@idrive.com</strong> and <strong>support@send.idrive.com</strong> to your contact list to make sure that emails get delivered to your inbox.</span>
                                    </div>
                                    <div className="common_txtBox_row">
                                        <label>Email Address</label>
                                        <input type="text" name="" value={ this.state.userEmail } className="txtBox" disabled />
                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns">
                                            <div className="btn blue verify_btn" onClick={ () => this.enableForgetPassword() }>Send Email</div>
                                            <div className="btn btn_cancel" onClick={ () => { $(".googleSignup_popup").removeClass("active"); } }>Cancel</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="captcha">
                    <ReCAPTCHA
                        sitekey="6LfMaG8aAAAAADtCmgI91y-9wbCjnaDTQwwIUv6-"
                        onChange={ (e) => this.onRecaptchaChange(e) }
                        ref={ this.recaptchaRef }
                        size="invisible"
                    />
                </div>
            </React.Fragment>
        );
    }
}
function splitcountryCode(cncode) {
    if(cncode != null && cncode != "" && cncode.length > 0) {
        let code = cncode.split("+");
        return "+" + code[1];
    }
    else {
        return "";
    }

}
export default Security;
